import React from "react";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import Slide from "@material-ui/core/Slide";
import SubmitButton from "../Button/SubmitButton";
import CancelButton from "../Button/CancelButton";
import ButtonWrapper from "../Button/ButtonWrapper";
import theme from "../../theme";
// import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonProps, DialogProps } from "../../@types/";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props}></Slide>;
// });

const useStyles = makeStyles(() => ({
  buttonContainer: {
    width: "80%",
    margin: "20px auto 0px",
    padding: "5px 0px 15px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "1fr",
    gap: "0px 0px",
    gridTemplateAreas: ". . ."
  }
}));

const PopUpDialog = (props: DialogProps) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    setOpen(false);
    props.onSubmit();
  };

  const cancelButtonProps: ButtonProps = {
    onClick: handleClose
  }

  const submitButtonProps: ButtonProps = {
    onClick: handleSubmit
  }

  return (
    <Box>
      <ButtonWrapper
        bgColor={theme.palette.primary.main}
        message={props.popupButtonTitle}
        onClick={handleClickOpen}
        icon={""}
      />
      <Dialog
        open={open}
        // TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {props.description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className={classes.buttonContainer}>
            <CancelButton {...cancelButtonProps}>Disagree</CancelButton>
            <div />
            <SubmitButton {...submitButtonProps}>Agree</SubmitButton>
          </div>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PopUpDialog;
